import './accordions.css'
import {useState} from 'react'
import Outlined from '../div/Outlined'

function Accordions() {
    const [openTeal, setOpenTeal] = useState(false)
    const [openTomato, setOpenTomato] = useState(false)
    const [openYellow, setOpenYellow] = useState(false)
  return (
  <div className='accordionsWrapper'>
  <h1 className='policies--title'>Read our policies</h1>
  <Outlined/>
    <div className='accordion'>
    <div className='accordion--heading'>
        <h1>Room regulations</h1>
        <span onClick={() => setOpenYellow(!openYellow)}>
            {openYellow ? <i className="fas fa-minus icon"></i> : <i className="icon fas fa-plus"></i>}
        </span>
    </div>
    {openYellow && (
        <div className='accordion--content'>
        <h4>The tenants should strictly observe the following regulations</h4> 
        <p> Avoid putting lound music from your hoffers as this can be a source of disturbance to other tenants</p>
        <p> Rent should be paid before the 8th day of the new month</p>
        <p> Any damages to the room should be paid when vaccating the room</p>
        <p> No hostage of illigal people in your room</p>
    </div>
    )}
    </div>
      <div className='accordion'>
    <div className='accordion--heading'>
        <h1>Property ownership</h1>
        <span onClick={() => setOpenTomato(!openTomato)}>
            {openTomato? <i className="fas fa-minus icon"></i> : <i className="icon fas fa-plus"></i>}
        </span>
    </div>
    {openTomato && (
        <div className='accordion--content'>
      <p>For our lands, motors and furnitures you become a legal
       owner of the property only after full payment for the property has 
       been made and the necessary authorization details have been handed to you from us. Incase of any attempt to own property from us in illegal ways, you'll be sued and heavy fines and punishement will follow you.</p>
    </div>
    )}
    </div>
      <div className='accordion'>
    <div className='accordion--heading '>
        <h1>Payment rules</h1>
        <span onClick={() => setOpenTeal(!openTeal)}>
            {openTeal? <i className="fas fa-minus icon"></i> : <i className="icon fas fa-plus"></i>}
        </span>
    </div>
    {openTeal && (
        <div className='accordion--content'>
        <p>Payment of property is done via Paypay, Bank transfers or M-pesa. The following are the banks we work with: <br></br>
        Equity Bank<br></br>
        National Bank<br></br>
        Co-operative Bank<br></br>
        KCB Bank<br></br>
        </p>
    </div>
    )}
    </div>
  </div>
  );
}

export default Accordions;
